import type * as Operator from '../operators';

const KYC_OPERATOR_MAP = {
  caf: undefined as unknown as Operator.CafKyc,
  legitimuz: undefined as unknown as Operator.LegitimuzKyc,
  pay2free: undefined as unknown as Operator.Pay2FreeKyc,
  serasa: undefined as unknown as Operator.SerasaKyc,
};

export type KycOperator = typeof KYC_OPERATOR_MAP;
export type KycOperatorName = keyof typeof KYC_OPERATOR_MAP;
export type KycOperators = KycOperator[KycOperatorName];

export const KYC_OPERATOR_NAMES = Object.keys(
  KYC_OPERATOR_MAP,
) as KycOperatorName[];
